import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Validates that a redirect path is a safe relative URL.
 * Prevents open redirect attacks by rejecting absolute URLs,
 * protocol-relative URLs, and other dangerous patterns.
 */
export function getSafeRedirect(redirect: string | null | undefined, fallback = '/home'): string {
  if (!redirect) return fallback;
  
  try {
    const decoded = decodeURIComponent(redirect);
    // Must start with / and not be protocol-relative (//)
    // Also reject URLs with backslashes or embedded protocols
    if (
      !decoded.startsWith('/') ||
      decoded.startsWith('//') ||
      decoded.includes(':\\') ||
      decoded.includes(':/') ||
      /^\/[^/]*@/.test(decoded)
    ) {
      return fallback;
    }
    return decoded;
  } catch {
    return fallback;
  }
}
